import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';


function Header() {

  const {
    shortCutData,
    nickName
  } = useSelector(state => state.commonReducer)

  return (
    <div className={styles["shortcut-2014"]}>
      <div className={`w ${styles.w}`}>
        <ul className="fl">
          <li className="ttbar-home">
            <a href={shortCutData?.left?.linkText} alt=''>{shortCutData?.left?.text}</a>
          </li>
        </ul>
        <ul className="fr">
          {
            shortCutData?.right?.map((navItem, navItemIdx, navArr) => {
              const text = navItem?.text;
              const linkText = navItem?.linkText;
              if (navItemIdx === 0) {
                const url = !nickName ? linkText : '//home.jd.hk';
                const user = !nickName ? text : nickName;
                return (
                  <React.Fragment key={`${text}-${navItemIdx}`}>
                    <li>
                      <a href={url} target="_blank" rel="noopener noreferrer">{user}</a>
                      {
                        nickName && <a href="https://passport.jd.com/uc/login?ltype=logout" className={styles["link-logout"]}>退出</a>
                      }
                    </li>
                    <li className={styles.spacer}></li>
                  </React.Fragment>
                )
              }
              if (navItem.codeImage) {
                return (
                  <React.Fragment key={`${text}-${navItemIdx}`}>
                    <li className={styles.dorpdown}>
                      <div className={`${styles.dt} ${styles["cw-icon"]}`}>
                        <i className={styles["watch-left"]}></i> 关注全球购
                        <i className={styles["ci-right"]}><s>◇</s></i>
                      </div>
                      <div className={`${styles.dd} ${styles["dorpdown-layer"]}`}>
                        <div className={styles["dd-spacer"]}></div>
                        <div className={styles["dd-inner"]}>
                          <i className={styles.qrcode} style={{backgroundImage: `url(${navItem.codeImage})`}}></i>
                          <div>扫一扫</div>
                        </div>
                      </div>
                    </li>
                    <li className={styles.spacer}></li>
                  </React.Fragment>
                )
              }
              return (
                <React.Fragment key={`${text}-${navItemIdx}`}>
                  <li>
                    <div className={styles.dt}>
                      <a target="_blank" href={linkText} rel="noopener noreferrer">
                        {text}
                      </a>
                    </div>
                  </li>
                  {
                    navItemIdx !== navArr.length - 1 && <li className={styles.spacer}></li>
                  }
                </React.Fragment>
              )
            })
          }
        </ul>
        <span className="clr"></span>
      </div>
    </div>
  )
}

export default Header;